import React from "react";
import _ from 'lodash';
import LockIcon from '@material-ui/icons/Lock';
import YesNoField from "fields/YesNoField";

const IsLockedField = ({record, source, showComment, commentSource, showNo}) => {
  const comment = _.get(record, commentSource, '');
  return <YesNoField source={source}
                     record={record}
                     comment={comment}
                     showComment={showComment}
                     yesText={<LockIcon/>}
                     showNo={showNo}/>
};

IsLockedField.defaultProps = {
  showComment: false,
  commentSource: 'locked_at',
  showNo: true,

  source: 'locked_at',
  label: 'Is locked',
  addLabel: true,
};

export default IsLockedField;